



import {Component, Vue, Prop} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {SvgRender}
})
export default class DatePicker extends Vue {
  @Prop({ required: false, type: String, default: 'calendar' }) leftIcon!: string

  private value = null

  private now = new Date()

  private onContext(ctx: { selectedYMD: string; }) {
    if(ctx.selectedYMD != '') this.$emit('onClickDate', ctx.selectedYMD)
  }
  private clickOutSide():void {
    this.$emit('onClickOutSide')
  }
}
